import { z } from 'zod';

// ─────────── Multas de trânsito: quem estava com o carro na hora da infração ───────────

export const RESPONSAVEIS_MULTA = ['comprador', 'test_drive', 'antigo_dono', 'loja'] as const;
export type ResponsavelMulta = (typeof RESPONSAVEIS_MULTA)[number];
export const NOME_RESPONSAVEL_MULTA: Record<ResponsavelMulta, string> = {
  comprador: 'Comprador (carro já vendido)',
  test_drive: 'Cliente em test drive',
  antigo_dono: 'Dono anterior (antes de entrar na loja)',
  loja: 'Loja',
};

export const STATUS_MULTA = [
  'aberta',
  'repassada',
  'paga',
  'condutor_indicado',
  'cancelada',
] as const;
export type StatusMulta = (typeof STATUS_MULTA)[number];
export const NOME_STATUS_MULTA: Record<StatusMulta, string> = {
  aberta: 'Em aberto',
  repassada: 'Cobrada do responsável',
  paga: 'Paga',
  condutor_indicado: 'Condutor indicado',
  cancelada: 'Cancelada',
};

/** Janela do test drive em volta do horário marcado (não há horário de volta registrado). */
export const JANELA_TEST_DRIVE = { antesMin: 30, depoisMin: 180 };

const dia = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Data inválida (AAAA-MM-DD)')
  .refine((v) => !Number.isNaN(new Date(`${v}T00:00:00Z`).getTime()), 'Data inválida');
const textoOpc = (max: number) =>
  z
    .string()
    .trim()
    .max(max)
    .transform((v) => (v === '' ? null : v))
    .nullable()
    .optional();

export const multaCriarSchema = z.object({
  placa: z
    .string()
    .trim()
    .toUpperCase()
    .transform((p) => p.replace(/[^A-Z0-9]/g, ''))
    .refine((p) => /^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/.test(p), 'Placa inválida'),
  autoInfracao: z.string().trim().min(3, 'Número do auto de infração').max(30),
  orgao: z.string().trim().min(2).max(80),
  dataHora: z.coerce.date(),
  descricao: z.string().trim().min(3).max(300),
  valorCentavos: z.number().int().min(1).max(10_000_000),
  pontos: z.number().int().min(0).max(21).nullable().optional(),
  /** prazo para indicar o condutor */
  prazoIndicacao: dia.nullable().optional(),
  vencimento: dia.nullable().optional(),
  /** lançar no financeiro a conta a pagar ao órgão */
  lancarPagamento: z.boolean().default(true),
  observacoes: textoOpc(500),
});
export type MultaCriar = z.infer<typeof multaCriarSchema>;

export const multaRepasseSchema = z.object({
  vencimento: dia,
  /** inclui uma taxa de serviço (despachante) no repasse */
  taxaCentavos: z.number().int().min(0).max(1_000_000).default(0),
});
export const multaStatusSchema = z.object({
  status: z.enum(['paga', 'condutor_indicado', 'cancelada', 'aberta']),
  observacoes: textoOpc(500),
});
